// extracted by mini-css-extract-plugin
export default {"product-summary":"Price_product-summary__sCS5g","product-summary--price":"Price_product-summary--price__1AOW1","product-summary--scale":"Price_product-summary--scale__33NrR"};